import { AfterViewInit, Component, HostListener, ViewEncapsulation } from '@angular/core';
import { TranslationsService } from '@core/services/common/translations.service';
import { isTargetClickable, setWhiteBackgroundIfNothingSet } from '@modules/cursors/helpers/helpers';
import { SessionStorageService } from '@shared/services/storage';

@Component({
  selector: 'app-circle-text-cursor',
  template: `
    <div class="cursor">
      <div class="circle" [class.big]="isBig">
        <div class="text">{{ text[lang] }}</div>
      </div>
    </div>`,
  styles: [`
    body, body * {
      cursor: none !important;
    }

    app-cursors-wrapper {
      mix-blend-mode: difference;
    }

    .cursor {
      pointer-events: none;
    }

    .circle {
      background: #fff;
      overflow: hidden;
      width: 50px;
      height: 50px;
      transition: all 0s, scale 0.1s !important;
      display: grid;
      place-items: center;
      border-radius: 50%;
    }

    .circle.big {
      scale: 3;
    }

    .text {
      display: none;
      font-size: 10px;
      text-transform: uppercase;
      font-family: sans-serif;
      animation: rotate 5s linear infinite;
    }

    .circle.big .text {
      display: block;
    }

    @keyframes rotate {
      from {
        rotate: 0deg;
      }
      to {
        rotate: 360deg;
      }
    }

    @-webkit-keyframes rotate {
      from {
        rotate: 0deg;
      }
      to {
        rotate: 360deg;
      }
    }
  `],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class CircleTextCursorComponent implements AfterViewInit {
  private circle: HTMLElement;
  private mouseX = 0;
  private mouseY = 0;
  isBig = false;
  lang: string;
  text = {
    en: 'click',
    de: 'klicken',
    es: 'hacer clic',
    fr: 'cliquer',
    ru: 'щелкнуть',
    pl: 'kliknij',
  };

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(e: any): void {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
    this.isBig = isTargetClickable(e.target);
  }

  constructor(
    translationsService: TranslationsService,
    sessionStorage: SessionStorageService,
  ) {
    this.lang = sessionStorage.getItem('language') || 'en';
    translationsService.langChanged.subscribe(lang => {
      this.lang = lang;
    });
  }

  ngAfterViewInit(): void {
    setWhiteBackgroundIfNothingSet();
    this.circle = document.querySelector('.cursor .circle') as HTMLElement;

    requestAnimationFrame(() => this.animate());
  }

  private animate(): void {
    if (this.circle) {
      this.circle.style.translate = `${this.mouseX - 25}px ${this.mouseY - 25}px`;
    }

    requestAnimationFrame(() => this.animate());
  }
}
